module.exports = __webpack_public_path__ + "img/section3Card3Topbg.9eebef1e.png";